<script setup lang="ts">
import ContentView from './ContentView.vue';
import SpinnerOverlay from '@/components/common/SpinnerOverlay.vue';
import SalesRepContactButton from '@/components/common/SalesRepContactButton.vue';
import AboutWidget from '@/components/widgets/about-widget/AboutWidget.vue';
import ExportButton from '@/components/common/ExportButton.vue';
import ExternalLinks from '@/components/common/ExternalLinks.vue';
import { HealthBoardIcon, HealthCareIcon, PeopleIcon, PillsIcon } from '@/components/icons';
import { storeToRefs } from 'pinia';
import { useThemeStore, useValueDataStore } from '@/stores';
import DbgHealthLogo from '@/components/icons/DbgHealthLogo.vue';
import ArrotexLogo from '@/components/icons/ArrotexLogo.vue';
import VidacorpLogo from '@/components/icons/VidacorpLogo.vue';
import AxeLogo from '@/components/icons/AxeLogo.vue';
import { computed } from 'vue';
// import DataRefreshDatesButton from '@/components/common/DataRefreshDatesButton.vue';

const themeStore = useThemeStore();
const { themeColors } = themeStore;
const { isValueDataStoreLoading } = storeToRefs(useValueDataStore());

const aboutWidgets = computed(() => [
  {
    isMain: true,
    number: '‎',
    showGlow: true,
    title: 'DBG\nHEALTH',
    bullets: ['Pharmaceuticals', 'Consumer Health', 'Health Services'],
    captions: [
      { rank: '1', text: 'Pharmacy Pharma Company' },
      { rank: '1', text: 'Hospital Pharma Company' },
      { rank: '1', text: 'Private Label OTC Medicines Company' },
      { rank: '1', text: 'Cosmetics Company' }
    ],
    path: '/benefits',
    logoComponent: DbgHealthLogo,
    iconComponent: HealthCareIcon,
    logoProps: { height: '4.6875rem', width: '7.8125rem', fill: themeColors.colorBackgroundBright },
  },
  {
    number: '01',
    title: 'PHARMA-CEUTICAL',
    path: '/benefits/arrotex',
    bullets: ['Generic Pharmaceuticals', 'Branded Pharmaceuticals', 'Biologics and Biosimilars'],
    captions: [
      { rank: '1', text: 'Pharmacy Pharma Company' },
      { rank: '1', text: 'Hospital Pharma Company' },
      { rank: '1', text: 'Brand Pharma Company' }
    ],
    color: '#2AACE2',
    logoComponent: ArrotexLogo,
    iconComponent: PillsIcon,
    logoProps: { width: '7.8125rem', height: '3.125rem', fill: themeColors.colorText },
  },
  {
    number: '02',
    title: 'CONSUMER HEALTH',
    path: '/benefits/vidacorp',
    bullets: ['Private Label OTC Medicines', 'Branded OTC Medicines', 'Beauty Products', 'Skincare'],
    captions: [
      { rank: '1', text: 'Private Label OTC Medicines Company' },
      { rank: '1', text: 'Cosmetics Company' }
    ],
    color: '#2CCE86',
    logoComponent: VidacorpLogo,
    iconComponent: PeopleIcon,
    logoProps: { width: '7.8125rem', height: '3.125rem', fill: themeColors.colorText },
  },
  {
    number: '03',
    title: 'HEALTH SERVICES',
    path: '/benefits/axe',
    bullets: ['Pharma Consulting', 'Health Programs', 'Vaccines', 'Nurse Services', 'Business Data Services', 'Medical Detailing'],
    captions: [
      { text: 'Largest Medical Detailing Field Force' },
      { text: 'Leading Pharmacy Medicines Program' }
    ],
    color: '#5A5BC1',
    logoComponent: AxeLogo,
    iconComponent: HealthBoardIcon,
    logoProps: { width: '4.6875rem', height: '3.125rem', fill: themeColors.colorText },
  }
]);
</script>

<template>
  <SpinnerOverlay v-if="isValueDataStoreLoading" />
  <ContentView>
    <template #top>
      <!-- <DataRefreshDatesButton/> -->
      <ExternalLinks />
      <SalesRepContactButton label="Contact your Arrotex Rep" type="arrotex" />
      <SalesRepContactButton label="Contact your VidaCorp Rep" type="vidacorp" />
      <ExportButton />
    </template>
    <template #middle>
      <AboutWidget
        v-for="widget in aboutWidgets"
        :key="widget.path"
        v-bind="widget"
      >
        <template #logo>
          <component :is="widget.logoComponent" v-bind="widget.logoProps" />
        </template>
        <template #icon>
          <component :is="widget.iconComponent" class="icon" :class="{main: widget.isMain}" />
        </template>
      </AboutWidget>
    </template>
  </ContentView>
</template>

<style scoped>
.title {
  font-size: 1.125rem;
  font-weight: 600;
}

.icon {
  font-size: 2.25rem;
  width: 30%;
}

.icon.main {
  font-size: 3.125rem;
}
</style>
